import { t } from '@lingui/macro';

export const columns = () => [
  { id: 'id', label: t`ID`, sortable: true, db_accessor: 'id' },
  { id: 'name', label: t`Dispositivo`, sortable: true, db_accessor: 'name' },
  { id: 'type', label: t`Tipo`, sortable: false },
  {
    id: 'organization_name',
    label: t`Organización`,
    sortable: false,
    db_accessor: 'organization_name',
  },
  {
    id: 'name_project',
    label: t`Proyecto`,
    sortable: false,
    db_accessor: 'name_project',
  },
  {
    id: 'progress',
    label: t`Progreso`,
    sortable: false,
  },
  {
    id: 'actions',
    label: t`Acciones`,
    sortable: false,
  },
];
